package app.nestbridge.feature.children.ui

import app.nestbridge.feature.children.screen.ChildDetailScreen
import app.nestbridge.feature.children.screen.ChildDetailState
import com.slack.circuit.runtime.CircuitContext
import com.slack.circuit.runtime.screen.Screen
import com.slack.circuit.runtime.ui.Ui
import com.slack.circuit.runtime.ui.ui
import me.tatarka.inject.annotations.Inject
import software.amazon.lastmile.kotlin.inject.anvil.AppScope
import software.amazon.lastmile.kotlin.inject.anvil.ContributesBinding

@Inject
@ContributesBinding(
  AppScope::class,
  multibinding = true,
)
public class ChildDetailUiFactory : Ui.Factory {
  override fun create(screen: Screen, context: CircuitContext): Ui<*>? = when (screen) {
    is ChildDetailScreen -> ui<ChildDetailState> { state, modifier -> ChildDetailUi(state = state, modifier = modifier) }
    else -> null
  }
}
